import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { CredsContext, HelpModeContext } from "./Contexts";
import DashboardPanelHeader from "./DashboardPanelHeader";
import StatusProjectHealth from "./StatusProjectHealth";
import Tools from "./JNSTools";
import {
  CircularGaugeComponent,
  AxesDirective,
  AxisDirective,
  PointersDirective,
  PointerDirective,
  RangesDirective,
  RangeDirective,
  AnnotationsDirective,
  AnnotationDirective,
  Inject,
  Annotations,
} from "@syncfusion/ej2-react-circulargauge";

function DashboardProjectHealth(props) {
  const helpMode = useContext(HelpModeContext).mode;
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const [showCalc, setShowCalc] = useState(false);
  const metrics = Tools.calculateProjectMetrics(projectObject, creds);
  /*const bac =
    parseFloat(projectObject.oada_project_booked_hours__c) > 0
      ? parseFloat(projectObject.oada_project_booked_hours__c)
      : parseFloat(projectObject.budget_time);
  const projStartDate = new Date(
    projectObject.start_date.substring(4, 8) +
      "-" +
      projectObject.start_date.substring(0, 2) +
      "-" +
      projectObject.start_date.substring(2, 4),
  );
  const projEndDate = new Date(
    projectObject.finish_date.substring(4, 8) +
      "-" +
      projectObject.finish_date.substring(0, 2) +
      "-" +
      projectObject.finish_date.substring(2, 4),
  );
  const daysDiffFromToday =
    today > projStartDate ? (today - projStartDate) / 86400000 + 1 : 0;
  let weeksFromToday = (daysDiffFromToday - (daysDiffFromToday % 7)) / 7;
  if (projStartDate.getDay() - today.getDay() > 1) {
    weeksFromToday++;
  }
  const daysIn = daysDiffFromToday - weeksFromToday * 2;

  const daysDiffTotal =
    projEndDate > projStartDate
      ? (projEndDate - projStartDate) / 86400000 + 1
      : 0;
  let weeksTotal = (daysDiffTotal - (daysDiffTotal % 7)) / 7;
  if (projStartDate.getDay() - projEndDate.getDay() > 1) {
    weeksTotal++;
  }
  const duration = daysDiffTotal - weeksTotal * 2;

  const calcPctComplete = daysIn / duration;
  const pv = calcPctComplete * bac;
  const actualPctComplete =
    parseFloat(projectObject.oada_project_pct_complete__c) / 100;
  const ev = actualPctComplete * bac;
  const ac = parseFloat(projectObject.oada_actual_hours__c);
  const cv = ev - ac;
  const sv = ev - pv;
  const cpi = ac > 0 ? ev / ac : 0;
  const spi = pv > 0 ? ev / pv : 0;
  const etc = cpi > 0 ? (bac - ev) / cpi : 0;
  const eac = ac + etc;
  const vac = bac - eac;
*/
  let title;
  let pointerValue;
  let annotationContent;
  let calcDescription;

  switch (props.metric) {
    case "SPI":
      title = "Schedule Health (SPI)";
      annotationContent =
        '<div><span style="font-size:medium;color:white;">SPI: ' +
        metrics.schedulePerformanceIndex.toFixed(2) +
        "</span></div>";
      pointerValue = metrics.schedulePerformanceIndex;
      calcDescription = (
        <Box>
          <Typography fontSize="13px">
            Calc % (C%) = Days since start / Duration
          </Typography>
          <Typography paddingLeft="15px" fontSize="13px">
            C% = {parseInt(metrics.daysIn)} / {parseInt(metrics.duration)}
            &nbsp;=&nbsp;
            {metrics.calcPctComplete.toFixed(2)}
          </Typography>
          <Typography fontSize="13px">
            Earned Value (EV) = % Complete * Budget
          </Typography>
          <Typography paddingLeft="15px" fontSize="13px">
            EV = {metrics.actualPctComplete.toFixed(2)} * {metrics.budgetHours}
            &nbsp;=&nbsp;
            {metrics.earnedValue.toFixed(2)}
          </Typography>
          <Typography fontSize="13px">
            Planned Value (PV) = Calc % * Budget
          </Typography>
          <Typography paddingLeft="15px" fontSize="13px">
            PV = {metrics.calcPctComplete.toFixed(2)} * {metrics.budgetHours} ={" "}
            {metrics.plannedValue.toFixed(2)}
          </Typography>
          <span>
            SPI = EV / PV = {metrics.earnedValue.toFixed(2)} /{" "}
            {metrics.plannedValue.toFixed(2)}&nbsp;=&nbsp;
          </span>
          <span style={{ fontWeight: "bold", fontSize: "16px", color: "blue" }}>
            {metrics.schedulePerformanceIndex.toFixed(2)}
          </span>
        </Box>
      );
      break;
    case "CPI-H":
      title = "Budget Health (CPI - Hours)";
      annotationContent =
        '<div><span style="font-size:medium;color:white;">CPI: ' +
        metrics.costPerformanceIndex.toFixed(2) +
        "</span></div>";
      pointerValue = metrics.costPerformanceIndex;
      calcDescription = (
        <Box
          sx={{
            fontSize: "13px",
            height: "135px",
            border: "solid 1px",
            padding: "0px 5px",
          }}
        >
          <Typography fontSize="13px">
            Earned Value (EV) = % Complete * Budget
          </Typography>
          <Typography paddingLeft="15px" fontSize="13px">
            EV = {metrics.actualPctComplete.toFixed(2)} * {metrics.budgetHours}
            &nbsp;=&nbsp;
            {metrics.earnedValue.toFixed(2)}
          </Typography>
          <span>CPI = EV / Actual Hours</span>
          <br></br>
          <span>
            &nbsp;=&nbsp;{metrics.earnedValue.toFixed(2)}&nbsp;/&nbsp;
            {metrics.actualHours}&nbsp;=&nbsp;
          </span>

          <span style={{ fontWeight: "bold", fontSize: "16px", color: "blue" }}>
            {metrics.costPerformanceIndex.toFixed(2)}
          </span>
        </Box>
      );
      break;
  }

  const handleClick = (event) => {
    setShowCalc(!showCalc);
  };

  return props.statusVersion ? (
    <StatusProjectHealth metricsObject={metrics} metricType={props.metric} />
  ) : (
    <>
      <Box
        className="dashTableTitleBar"
        height="12%"
        id={"__dashboardProjectHealth" + props.metric + "_header"}
        sx={{ cursor: helpMode ? "help" : "default" }}
      >
        <DashboardPanelHeader
          panelLocked={props.panelLocked}
          title={title}
          removePanel={props.removePanel}
          panelId={props.panelId}
        />
      </Box>
      <Box
        height="85%"
        sx={{
          overflow: "hidden",
          verticalAlign: "middle",
          border: "solid 2px",
          padding: "0px 0px 4px 4px",
          borderRadius: "0px 0px 6px 6px",
          backgroundColor: "slategray",
        }}
        id={"__dashboardProjectHealth" + props.metric}
      >
        {showCalc ? (
          <Box id={"showCalc" + props.metric} onClick={handleClick}>
            {calcDescription}
          </Box>
        ) : (
          <CircularGaugeComponent
            id={"gauge" + props.metric}
            background="slategray"
            centerY="140"
            margin={{
              left: 30,
              right: 30,
              top: 15,
              bottom: 0,
            }}
            sx={{ cursor: helpMode ? "help" : "default" }}
            onClick={helpMode ? null : handleClick}
          >
            <Inject services={[Annotations]} />
            <AxesDirective>
              <AxisDirective
                labelStyle={{
                  font: {
                    color: "white",
                    size: "14px",
                    fontWeight: "Normal",
                  },
                }}
                lineStyle={{
                  width: 1,
                  color: "black",
                }}
                radius="120"
                startAngle={270}
                endAngle={90}
                minimum={0.5}
                maximum={1.5}
                majorTicks={{
                  interval: 0.25,
                  color: "black",
                  height: 10,
                  width: 3,
                }}
                minorTicks={{
                  interval: 0.5,
                  color: "black",
                  height: 5,
                  width: 2,
                }}
              >
                <RangesDirective>
                  <RangeDirective
                    start={0.5}
                    end={0.85}
                    color="crimson"
                    startWidth="15"
                    endWidth="15"
                  ></RangeDirective>
                  <RangeDirective
                    start={0.85}
                    end={1.15}
                    color="#FFEE00"
                    startWidth="15"
                    endWidth="15"
                  ></RangeDirective>
                  <RangeDirective
                    start={1.15}
                    end={1.5}
                    color="green"
                    startWidth="15"
                    endWidth="15"
                  ></RangeDirective>
                </RangesDirective>
                <PointersDirective>
                  <PointerDirective
                    value={pointerValue}
                    cap={{
                      radius: 7,
                      color: "black",
                      border: {
                        color: "silver",
                        width: 5,
                      },
                    }}
                    needleTail={{
                      length: "0%",
                    }}
                    color="silver"
                    pointerWidth={15}
                  ></PointerDirective>
                </PointersDirective>
                <AnnotationsDirective>
                  <AnnotationDirective
                    content={annotationContent}
                    angle={320}
                    radius="128%"
                    zIndex="1"
                  />
                </AnnotationsDirective>
              </AxisDirective>
            </AxesDirective>
          </CircularGaugeComponent>
        )}
      </Box>
    </>
  );
}

export default DashboardProjectHealth;

DashboardProjectHealth.propTypes = {
  metric: PropTypes.string,
  panelLocked: PropTypes.bool,
  removePanel: PropTypes.func,
  panelId: PropTypes.number,
  statusVersion: PropTypes.bool,
};
